require('./forwebmasters/reservationWidget');

jQuery.fn.selectText = function(){
    var doc = document
        , element = this[0]
        , range, selection
    ;
    if (doc.body.createTextRange) {
        range = document.body.createTextRange();
        range.moveToElementText(element);
        range.select();
    } else if (window.getSelection) {
        selection = window.getSelection();        
        range = document.createRange();
        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);
    }
};

function updateUrl(){
	var url = '//' + embedBaseUrl + '/' + $('#embed_restaurant_id').val() + '/' + $('#reservation_language').val() + '/' + $('#reservation_background_color').val();
	$('iframe.example').attr('src', url);
    var re = new RegExp("/\/"+embedBaseUrl+"\/[0-9]*\/[a-zA-Z]*\/[a-zA-Z]*", "g");
	$('.reservation_module pre.prettyprint').html($('.reservation_module pre.prettyprint').html().replace(re, url));

	if($('#reservation_background_color').val() == 'light'){
		$('iframe.example').closest('div').css('background-color', 'white')
	}
	else{
		$('iframe.example').closest('div').css('background-color', '#232323')
	}
}

function updateMenuUrl(){
    var url = '//' + embedBaseUrl + '/menu/' + $('#embed_restaurant_id').val() + '/' + $('#menu_language').val() + '/' + $('#menu_background_color').val();
    $('iframe.menu-example').attr('src', url);
    var re = new RegExp("/\/"+embedBaseUrl+"\/menu\/[0-9]*\/[a-zA-Z]*\/[a-zA-Z]*", "g");
    $('.menu_module pre.prettyprint').html($('.menu_module pre.prettyprint').html().replace(re, url));


    if($('#menu_background_color').val() == 'light'){
        $('iframe.menu-example').closest('div').css('background-color', 'white')
    }
    else{
        $('iframe.menu-example').closest('div').css('background-color', '#232323')
    }
}

function updateFeedbackUrl(){
    var url = '//' + embedBaseUrl + '/feedback/' + $('#embed_restaurant_id').val() + '/' + $('#feedback_language').val() + '/' + $('#feedback_background_color').val();
    $('iframe.feedback-example').attr('src', url);
    var re = new RegExp("/\/"+embedBaseUrl+"\/feedback\/[0-9]*\/[a-zA-Z]*\/[a-zA-Z]*", "g");
    $('.feedback_module pre.prettyprint').html($('.feedback_module pre.prettyprint').html().replace(re, url));

    if($('#feedback_background_color').val() == 'light'){
        $('iframe.feedback-example').closest('div').css('background-color', 'white')
    }
    else{
        $('iframe.feedback-example').closest('div').css('background-color', '#232323')
    }
}

function goToByScroll(id){
    var scrollBy = $("#"+id).offset().top;
    
	$('html,body').animate({scrollTop: scrollBy-66}, 'slow');
}

$(function () {
	prettyPrint();
	updateUrl();
	
	$('#reservation_language').on('change', updateUrl);
	$('#reservation_background_color').on('change', updateUrl);

    if($('.menu_module').length > 0){
        updateMenuUrl();
        $('#menu_language').on('change', updateMenuUrl);
        $('#menu_background_color').on('change', updateMenuUrl);
    }

    if($('.feedback_module').length > 0){
        updateFeedbackUrl();
        $('#feedback_language').on('change', updateFeedbackUrl);
        $('#feedback_background_color').on('change', updateFeedbackUrl);
    }

	$('.plugin').tooltip({'placement': 'top'});
	
	$('pre.prettyprint').on('click', function(){
		$(this).selectText();
	});
	
	$('#show_movie').on('click', function(e){
		e.preventDefault();
		$('#movie_modal').modal();
	});
	
	$('.scroll_on_click').on('click', function(e){
		e.preventDefault();
		goToByScroll($(this).data('anchor-id'));
	});
	
});


// WEBPACK FOOTER //
// ./pages/embed.js